(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-collections"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.rgInit)return;
    root.dataset.rgInit='1';
    var track=root.querySelector('.rg-coll__track'),dotsBox=root.querySelector('.rg-coll__dots');
    if(!track||!dotsBox)return;
    var cards=[].slice.call(track.querySelectorAll('.rg-coll__card')),dots=[];
    cards.forEach(function(c,i){
      var b=document.createElement('button');
      b.type='button';b.className='rg-coll__dot';b.setAttribute('aria-label','Carte '+(i+1));
      b.addEventListener('click',function(){track.scrollTo({left:c.offsetLeft-track.offsetLeft-16,behavior:'smooth'});});
      dotsBox.appendChild(b);dots.push(b);
    });
    function update(){
      if(!cards.length)return;
      var x=track.scrollLeft,best=0,min=1e9;
      cards.forEach(function(c,i){var d=Math.abs((c.offsetLeft-track.offsetLeft-16)-x);if(d<min){min=d;best=i;}});
      dots.forEach(function(d,i){d.classList.toggle('is-active',i===best);});
    }
    track.addEventListener('scroll',function(){window.requestAnimationFrame(update);},{passive:true});
    window.addEventListener('resize',update);
    update();
  }
  function all(){document.querySelectorAll('[data-rg-coll]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-product-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.rgInit) return;
    root.dataset.rgInit = '1';
    var track = root.querySelector('.rg-pcs__track');
    var prev = root.querySelector('[data-dir=prev]');
    var next = root.querySelector('[data-dir=next]');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.querySelector('.rg-pc');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function update() {
      prev.hidden = track.scrollLeft < 4;
      next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function initAll() { document.querySelectorAll('[data-rg-pcs]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
